module.exports = __webpack_public_path__ + "KaTeX_SansSerif-Italic.e3e03c54.ttf";